<template>
  <div class="d-flex justify-center" :style="{ width: !isModal ? 'calc(100vw - 338px)' : '100%' }">
    <div v-if="isLoadingFems" class="d-flex datafeedLoadingIndicator">
      <v-progress-circular
        :size="200"
        :width="8"
        indeterminate
        color="blue darken-2"
      ></v-progress-circular>
    </div>
    <div style="background:white;" class="product-data-title" :class="{ 'px-3': isModal }">
      <div v-if="!isLoadingFems" class="configureActionsContainer" :class="{ isMobileSized }">
        <div class="configureActions" :class="{ isMobileSized }">
          <div :style="isMobileSized ? '' : 'position: absolute; right: 0; top: 0;'">
            <v-btn
              v-if="isModal"
              color="grey lighten-1"
              class="white--text"
              :class="{ 'mr-3': !shouldShowAdjustMappingButton }"
              :small="isMobileSized"
              @click="
                guibus_publish('dispatch:beacon', {
                  eventId: `welcome-product_data_form_cancel_button-click${
                    isMobileSized ? '-mobile' : ''
                  }`,
                })
                $emit('closeModal')
              "
              >Cancel</v-btn
            >
            <v-btn
              v-if="shouldShowAdjustMappingButton"
              :disabled="!isProductsLoaded"
              color="blue-grey lighten-2"
              class="white--text mx-3"
              :small="isMobileSized"
              @click="
                guibus_publish('dispatch:beacon', {
                  eventId: `welcome-product_data_form_adjust_mapping_button-click${
                    isMobileSized ? '-mobile' : ''
                  }`,
                })
                showDatafeedEditMappingModal = true
              "
              >{{ isMobileSized ? 'Mapping' : 'Adjust Mapping' }}</v-btn
            >
            <v-btn
              :disabled="!isMandatoryHeadersMapped"
              color="primary"
              :small="isMobileSized"
              @click="saveAndContinue"
              >Confirm</v-btn
            >
          </div>
          <div class="font-weight-bold" :class="isMobileSized ? 'text-h6 mt-2' : 'text-h4 pa-3'"
            >Configure your product data</div
          >
        </div>
      </div>
      <div class="modalScrollArea" :class="{ isMobileSized }">
        <div v-if="isFreemium" class="caption" :class="{ 'px-3': !isMobileSized }">
          As a freemium user, you can process up to 50 products. You can upgrade to a paid plan
          later if you wish to process more products.
        </div>
        <div v-else-if="!hasValidPaymentInfo" class="caption">
          Without valid payment information, you can process only up to 5 products. If you wish to
          process more products, click <a @click="showBillingModal = true">here</a> to update your
          payment information.
        </div>
        <div
          id="datafeed-edit"
          class="datafeedEditDiv"
          :class="{ isMobileSized }"
          :data-adacado-dataset="datasetObjForDatafeed"
          :style="{ width: isMobileSized ? `${$vuetify.breakpoint.width - 72}px` : '1000px' }"
        >
          <div v-pre class="datafeedWrapper"></div>
        </div>
        <div v-if="isProductsLoaded" :class="{ 'px-3': !isMobileSized }">
          <div class="text-h6 font-weight-bold">Sample product data</div>
          <div class="caption" v-if="isMandatoryHeadersMapped"
            >This is a sample of your product data. Please review and confirm that the data is
            correct.</div
          >
          <div v-if="!isMandatoryHeadersMapped" class="red--text"
            >One or more mandatory fields were unable to be mapped. Please click 'Adjust Mapping' to
            map the necessary fields.</div
          >
        </div>
        <div v-show="isLoadingProductListFEMS" class="d-flex">
          <v-progress-circular
            v-show="isLoadingProductListFEMS"
            :size="100"
            :width="4"
            indeterminate
            color="blue darken-2"
          ></v-progress-circular>
        </div>
        <div id="products-list" :data-adacado-dataset="datasetObjForProductsList">
          <div v-pre class="productsListWrapper"></div>
        </div>
      </div>
    </div>
    <!-- datafeed edit mapping modal -->
    <ModalWrapper
      v-model="showDatafeedEditMappingModal"
      femsName="datafeed-edit"
      femsVersion="v2"
      :aEvents="aEvents"
      :modalDataSet="modalDataSetForDatafeedEditMapping"
    />
    <!-- hint modal -->
    <HintModal v-if="showHint" :currentHint="currentHint" @closeHint="closeHint" />
    <v-dialog v-model="showBillingModal" max-width="600" persistent>
      <BillingForm
        :isModal="true"
        @validate="handleBillingInfoSave"
        @close="showBillingModal = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import Parameter from 'parameter-mixin'
import ModalWrapper from 'component-modal-wrapper'
import FemsService from 'fems-service'
import HintModal from '../modals/Hint'
import BillingForm from './BillingForm'

export default {
  mixins: [Parameter],
  components: {
    ModalWrapper,
    HintModal,
    BillingForm,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    advertiser: {
      type: Object,
    },
    isMobileSized: {
      type: Boolean,
      default: true,
    },
    dataFeedSettingsProps: {
      type: Object,
    },
    isFreemium: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoadingFems: true,
      isProductsLoaded: false,
      inventoryItems: [],
      headers: [],
      dataFeedSettings: this.dataFeedSettingsProps,
      showDatafeedEditMappingModal: false,
      isMandatoryHeadersMapped: false,
      isLoadingProductListFEMS: false,
      aEvents: [
        {
          eventName: 'closeDatafeedEditModal',
          callback: () => {
            this.showDatafeedEditMappingModal = false
          },
        },
      ],
      hintsViewed: JSON.parse(localStorage.getItem('hintsViewed')) || [],
      showHint: false,
      productFeedHint: {
        HintID: 1,
        Title: 'How do I import products?',
        Description:
          'How do I import products? What is a product ad? What is a product feed? Watch this quick overview video to gain a better understanding of how to use your products with Adacado ads.',
        Media: { Type: 'video', Link: 'vJ6Xrb2Fn88' },
        Dependencies: [],
        ButtonText: '',
        LearnMore: 'https://adacado.com/support/data-feeds',
        TargetElementClass: 'product-data-title',
        HintPosition: 'window-center',
      },
      hasValidPaymentInfo: false,
      showBillingModal: false,
      shouldShowAdjustMappingButton: true,
    }
  },
  mounted() {
    this.guibus_subscribe('mounted:datafeedFems', this.handleDatafeedMounted)
    this.guibus_subscribe('fetched:sampleProductData', this.handleSampleFetch)
    this.guibus_subscribe('mounted:productsList', this.handleProductsListMounted)
    this.guibus_subscribe('selected:datafeedProtocol', this.handleProtocolSelection)
    if (!this.isFreemium) {
      this.validateBilling()
    }
    FemsService.renderChildFems('datafeed-edit', 'v2')
  },
  beforeDestroy() {
    this.guibus_unsubscribe('mounted:datafeedFems', this.handleDatafeedMounted)
    this.guibus_unsubscribe('fetched:sampleProductData', this.handleSampleFetch)
    this.guibus_unsubscribe('mounted:productsList', this.handleProductsListMounted)
    this.guibus_unsubscribe('selected:datafeed-protocol', this.handleProtocolSelection)
    FemsService.teardownChildFems('datafeed-edit', 'v2')
    FemsService.teardownChildFems('products-list', 'v2')
  },
  computed: {
    BillingAccountInterface() {
      return window.adacado.bscs ? window.adacado.bscs.BillingAccountInterfaceFactory() : undefined
    },
    currentHint() {
      if (!this.isLoadingFems && !this.hintsViewed.includes(this.productFeedHint.HintID)) {
        return this.productFeedHint
      }
      return undefined
    },
    datasetObjForDatafeed() {
      return this.$constructAdacadoDataset({
        advertiser: this.advertiser,
        isQuickStart: true,
        dataFeedSettings: this.dataFeedSettings || undefined,
      })
    },
    datasetObjForProductsList() {
      return this.$constructAdacadoDataset({
        inventoryItems: this.inventoryItems,
        isQuickStart: true,
        vertical: this.advertiser.Vertical,
      })
    },
    modalDataSetForDatafeedEditMapping() {
      return {
        isPersistent: true,
        noClickAnimation: true,
        isModal: true,
        advertiser: this.advertiser,
        dataFeedSettings: this.dataFeedSettings,
        headers: this.headers,
        isQuickStart: true,
        mode: 'mapping',
        width: this.isMobileSized ? this.$vuetify.breakpoint.width - 48 : 1000,
      }
    },
  },
  methods: {
    handleBillingInfoSave() {
      this.validateBilling()
      this.showBillingModal = false
    },
    async validateBilling() {
      await this.BillingAccountInterface.getHasValidPaymentInfo(response => {
        this.hasValidPaymentInfo = response
      })
    },
    closeHint(hintId) {
      this.showHint = false
      this.hintsViewed.push(hintId)
      localStorage.setItem('hintsViewed', JSON.stringify(this.hintsViewed))
    },
    saveAndContinue() {
      this.guibus_publish('dispatch:beacon', {
        eventId: `welcome-product_data_form_confirm_button-click${
          this.isMobileSized ? '-mobile' : ''
        }`,
      })
      this.$emit('saveAndContinue', {
        inventoryItems: this.inventoryItems,
        dataFeedSettings: this.dataFeedSettings,
      })
    },
    handleSampleFetch(payload) {
      FemsService.teardownChildFems('products-list', 'v2')
      this.isMandatoryHeadersMapped = payload.isMandatoryHeadersMapped
      this.inventoryItems = payload.productData
      this.headers = payload.headers
      this.dataFeedSettings = payload.dataFeedSettings
      this.isLoadingProductListFEMS = true
      this.$nextTick(() => {
        FemsService.renderChildFems('products-list', 'v2')
      })
    },
    handleProductsListMounted() {
      this.isProductsLoaded = true
      this.isLoadingProductListFEMS = false
    },
    handleDatafeedMounted() {
      this.isLoadingFems = false
      this.$nextTick(() => {
        this.showHint = true
      })
    },
    handleProtocolSelection(protocol) {
      if (protocol.protocolType === 'shopify') {
        this.shouldShowAdjustMappingButton = false
        return
      }
      this.shouldShowAdjustMappingButton = true
    },
  },
}
</script>

<style lang="scss" scoped>
.datafeedLoadingIndicator {
  height: 384px;
  justify-content: center;
  align-items: center;
  position: absolute;
}
.pageTitle {
  position: absolute;
  left: 15px;
}
.configureActions {
  position: relative;
}
.modalScrollArea {
  &.isMobileSized {
    max-height: 400px;
    overflow-y: scroll;
  }
}
</style>
